import { USER_PROFILE_DATA, USER_ROLE, MODULE_FLOW } from "../api/url";
import { getLocalStorageItem } from "../utils/storageHelper";
export var serviceAdviserInitialFilterValue = {
    ModelCode: [],
    Status: [],
    RepairType: [],
    Mode: [],
    StartDocDate: "",
    EndDocDate: ""
};
export var finalInspectorInitialFilterValue = {
    ModelCode: [],
    RepairType: [],
    Mode: [],
    StartDocDate: "",
    EndDocDate: ""
};
export var initialState = {
    openJobCardList: [],
    jobCardList: [],
    jobCard: {},
    closedJobCardList: [],
    draftJobCardDetails: {},
    jobCardSummary: [],
    appointmentDetails: {},
    vehicleHistoryDetails: {},
    filterPickList: [],
    profilePersonalDetails: getLocalStorageItem(USER_PROFILE_DATA),
    getUserRoles: getLocalStorageItem(USER_ROLE),
    getOtpNum: [],
    verifyOtp: {},
    filterValue: {},
    filterStatus: [],
    status: "idle",
    isOpenJcAdditionalJobsApproved: false,
    UpdateProfilePic: [],
    newEditDraftJC: {},
    RiderPickList: [],
    PreCheckList: [],
    GetVehicleList: [],
    NewEditJobCard: [],
    SaveRiderDetails: [],
    translateToJobItem: [],
    SetPropertyMobileNoAndSendOTP: [],
    SetPropertyMobileNoOTPText: [],
    RiderDetailsList: {},
    StandaredJobList: [],
    newEditVIResponse: {},
    saveVehicleInspectionResponse: {},
    CustomerVehiclesDetails: [],
    ServiceHistoryList: [],
    ServiceHistoryDetails: [],
    SaveCustomerComplaints: [],
    serviceDetails: [],
    LanguageList: [],
    RelationList: [],
    ContactPreferrenceList: [],
    getBranchList: [],
    getAppointmentList: [],
    repairTypeList: [],
    vehicleList: [],
    VehicleInspectionDetails: {},
    AppointmentInstallBase: [],
    standardJobsProductWisePartsAndLabour: {},
    ComplaintGroupList: [],
    ComplaintGroupBasedOnIdList: [],
    customerDetailsTrnalsteToJob: [],
    appointmentCount: {},
    vehicleInspectionCount: {},
    advisorList: [],
    ProfilePicUrl: '',
    profileAttachmentId: '',
    createVehicleInspectionData: {},
    documentDetailsGetById: {},
    createAndEditFlow: getLocalStorageItem(MODULE_FLOW),
    ModuleDetailsGetById: {},
    AssociateCustomerId: '',
    preDocumentFetch: [],
    FuelIndicatoreValue: [],
    RevisedEstimateIsExist: [],
    customerComplaintDataImageAndAudio: {},
    FinalInspectionChecklistCount: {
        customerComplaints: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        periodicMaintanance: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        standardJobs: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        additionalJobs: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        staticFIChecklist: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        dynamicFIChecklist: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        fastnerCheklist: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        },
        roadTest: {
            approvedCount: 0,
            totalCount: 0,
            rejectedCount: 0
        }
    },
    FIChecklistItemChange: {
        customerComplaints: {
            isItemRejected: false,
            isSaveClick: false
        },
        periodicMaintanance: {
            isItemRejected: false,
            isSaveClick: false
        },
        standardJobs: {
            isItemRejected: false,
            isSaveClick: false
        },
        additionalJobs: {
            isItemRejected: false,
            isSaveClick: false
        },
        staticFIChecklist: {
            isItemRejected: false,
            isSaveClick: false
        },
        dynamicFIChecklist: {
            isItemRejected: false,
            isSaveClick: false
        },
        fastnerCheklist: {
            isItemRejected: false,
            isSaveClick: false
        },
        roadTest: {
            isItemRejected: false,
            isSaveClick: false
        }
    },
    approveEstimate: {},
    menuValue: '',
    getParentDocumentId: {},
    TaskDetailsSectionSave: {
        periodicMaintainance: false
    },
    TotalPMPartPrice: 0,
    getCustomerInfo: {},
    getModuleHeaderCount: {},
    getStoredJobItems: [],
    getStoredSAComment: {},
    savedJobItemClick: false,
    CustomerComplaintList: {},
    fuelIndicatorSaved: false,
    finalInspectorObservationDetails: null,
    additionalEstimateDetail: null,
    savedJobItemCreateFlow: false,
    FIObservation: {},
    ucnDetails: {},
    getSearchByTypeList: [],
    PmPartCalculateLoader: false,
    repeatAlertConfiguration: null,
    selectedListViewType: 'list',
    callGetAlerts: 0,
    getAlertsByJobCardId: {},
    installBaseFindError: {},
    callReworkTabAPIS: null
};
